module.exports = __webpack_public_path__ + "media/images/nav/icon_15-7ac510b0147a0420cac7ab5faeca337e.svg";